import { countries } from '@material-dev/country-data';

export const DisplayCountryName = angular
    .module('checkout.components.displayCountryName', [])
    .component('displayCountryName', {
        template: '{{$ctrl.countries[$ctrl.countryCode].name || ""}}',
        bindings: {
            countryCode: '<'
        },
        controller: class DisplayCountryNameCtrl {
            constructor() {
                this.countries = countries;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/displayCountryName/displayCountryName.js